import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ContentReadOnlyMediaSessionQuery: GraphQLTaggedNode = graphql`
	query ContentReadOnlyMediaSessionQuery($contentId: ID!) {
		contentMediaSession(contentId: $contentId) {
			accessTokens {
				readOnlyToken {
					value
				}
			}
			configuration {
				clientId
				fileStoreUrl
			}
		}
	}
`;
